import {
  ICreatePaymentPromiseRequest,
  IPaymentPlanTerms,
  IPaymentPromise,
  IPortalInvoiceQuery,
  IPortalOpenInvoiceQueryRequest,
  IPortalInvoiceResponse,
} from "shared";

import { emptySplitApi } from "../baseApi";
import { PortalCacheTags } from "../cacheTags";

export const invoiceApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchInvoice: builder.query<IPortalInvoiceResponse, { code: string; resync?: boolean; sessionId: string }>({
      query: ({ code, resync, sessionId }) => ({
        url: `invoice/code/${code}`,
        method: `GET`,
        params: {
          resync: !!resync,
        },
        headers: {
          [`X-Portal-Session`]: sessionId,
          [`X-Portal-Hash-Code`]: code,
        },
      }),
      providesTags: [{ type: PortalCacheTags.Invoice, id: `LIST` }],
    }),
    createPaymentPlan: builder.mutation<void, { code: string; terms: IPaymentPlanTerms; sessionId: string }>({
      query: ({ code, terms, sessionId }) => ({
        url: `invoices/code/${code}/create-payment-plan`,
        method: `POST`,
        data: terms,
        headers: {
          [`X-Portal-Session`]: sessionId,
          [`X-Portal-Hash-Code`]: code,
        },
      }),
      invalidatesTags: [{ type: PortalCacheTags.Invoice, id: `LIST` }],
    }),
    createPaymentPromise: builder.mutation<IPaymentPromise, { code: string; sessionId: string } & ICreatePaymentPromiseRequest>({
      query: ({ code, sessionId, ...data }) => ({
        url: `invoices/code/${code}/promise`,
        method: `POST`,
        data,
        headers: {
          [`X-Portal-Session`]: sessionId,
          [`X-Portal-Hash-Code`]: code,
        },
      }),
      invalidatesTags: [{ type: PortalCacheTags.Invoice, id: `LIST` }],
    }),
    createInvoiceQuery: builder.mutation<IPortalInvoiceQuery, { code: string; sessionId: string } & IPortalOpenInvoiceQueryRequest>({
      query: ({ code, sessionId, ...data }) => ({
        url: `invoices/code/${code}/query`,
        method: `POST`,
        data,
        headers: {
          [`X-Portal-Session`]: sessionId,
          [`X-Portal-Hash-Code`]: code,
        },
      }),
      invalidatesTags: [{ type: PortalCacheTags.Invoice, id: `LIST` }],
    }),
  }),
});

export const {
  useFetchInvoiceQuery,
  useCreatePaymentPlanMutation,
  useCreatePaymentPromiseMutation,
  useCreateInvoiceQueryMutation,
} = invoiceApi;

